import React from 'react'
import { ReadOnlyFieldDisplay } from '../../../components/ReadOnlyFieldDisplay'
import { RouteTypeEnum, TradeFormValues } from '../Types'
import styles from './styles.module.less'

const ApexTradeFieldsPreview = ({
  values: { executionAlgorithm, market, orderId, routeType },
}: {
  values: TradeFormValues
}) => {
  return (
    <div className={`apex-trade-fields-preview ${styles.apexTradeFieldsPreview}`}>
      <div className={styles.apexTradeFieldsPreviewRow}>
        <ReadOnlyFieldDisplay className="route-type-preview" label="Route Type" required value={routeType} />
        <ReadOnlyFieldDisplay className="order-id-preview" label="Order ID" value={orderId} />
      </div>
      {routeType === RouteTypeEnum.Algo && (
        <div className={styles.apexTradeFieldsPreviewRow}>
          <ReadOnlyFieldDisplay
            className="exec-algo-preview"
            label="Execution Algorithm"
            required
            value={executionAlgorithm}
          />
        </div>
      )}
      {routeType === RouteTypeEnum.Dma && (
        <div className={styles.apexTradeFieldsPreviewRow}>
          <ReadOnlyFieldDisplay className="market-preview" label="Market" required value={market} />
        </div>
      )}
    </div>
  )
}

export default ApexTradeFieldsPreview
